var render = function render(_c,_vm){return _c('div',_vm._b({class:['product-text', _vm.data.class, _vm.data.staticClass],style:(_vm.data.style),attrs:{"id":_vm.data.id},domProps:{"innerHTML":_vm._s(_vm.props.item.text)}},'div',_vm.data.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }